import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingSpinnerProps {
  message?: string;
  size?: number;
  inline?: boolean;
}

// Reusable spinner component for consistent loading visuals across grids and auth flows.
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message, size = 40, inline = false }) => {
  const content = (
    <Box display="flex" flexDirection={inline ? 'row' : 'column'} alignItems="center" justifyContent="center" gap={inline ? 1.5 : 2}>
      <CircularProgress size={size} />
      {message && (
        <Typography variant="body2" sx={{ opacity: 0.8 }}>
          {message}
        </Typography>
      )}
    </Box>
  );
  return inline ? content : (
    <Box width="100%" display="flex" justifyContent="center" mt={2} mb={2}>
      {content}
    </Box>
  );
};

export default LoadingSpinner;
